module.exports = __webpack_public_path__ + "static/media/21ECLAC10.b8ba8a49.jpg";